import { ActionReducer, combineReducers, createFeature } from '@ngrx/store';

import { surveyCreationCoreReducer } from './core/survey-creation-core.reducer';
import { surveyCreationAudienceReducer } from './audience/survey-creation-audience.reducer';
import { insightsReducer } from './insights/survey-creation-insights.reducer';
import { surveyCreationReferenceReducer } from './reference/survey-creation-reference.reducer';
import { surveyCreationLaunchReducer } from './launch/survey-creation-launch.reducer';
import { INITIAL_SURVEY_CREATION_STATE } from './survey-creation-state.constants';
import { SurveyCreationState } from './survey-creation-state.model';
import { withCoreContext } from '../utils/core-context/survey-creation-action-core-context.helper';

export const surveyCreationFeatureKey = 'surveyCreation';

const combinedReducer = combineReducers<SurveyCreationState>({
  core: surveyCreationCoreReducer,
  audience: surveyCreationAudienceReducer,
  insights: insightsReducer,
  reference: surveyCreationReferenceReducer,
  launch: surveyCreationLaunchReducer,
});

// combineReducers gives a sub-reducer no way to read a sibling slice's state,
// so `audience`/`insights`/`launch` read core's rootSurveyId/activeChildKey/kind
// off the action instead, namespaced under `coreContext` so an action's own
// payload can never shadow it — see survey-creation-action-core-context.helper.ts.
const surveyCreationReducer: ActionReducer<SurveyCreationState> = (
  state = INITIAL_SURVEY_CREATION_STATE,
  action,
) => combinedReducer(state, withCoreContext(action, state.core));

export const surveyCreationFeature = createFeature({
  name: surveyCreationFeatureKey,
  reducer: surveyCreationReducer,
});
